import React from 'react'

const StallIcon = (props) => {
  return (
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" {...props} >
    <g>
      <g>
        <path d="M475.994,103.001c0-1.138-0.183-2.293-0.595-3.424l-33.879-93C440.081,2.628,436.327,0,432.124,0H79.876
          c-4.203,0-7.958,2.628-9.396,6.577l-33.879,93c-0.412,1.13-0.595,2.284-0.595,3.421c-0.003,0.001-0.006,0.001-0.009,0.002
          c0,0.129,0.009,0.256,0.01,0.385c0.002,0.052,0.001,0.104,0.004,0.156C36.303,128.105,56.365,148,80.998,148
          c14.125,0,26.744-6.547,35-16.76c8.256,10.213,20.875,16.76,35,16.76s26.744-6.547,35-16.76c8.256,10.213,20.875,16.76,35,16.76
          s26.744-6.547,35-16.76c8.256,10.213,20.875,16.76,35,16.76s26.744-6.547,35-16.76c8.256,10.213,20.875,16.76,35,16.76
          s26.744-6.547,35-16.76c8.256,10.213,20.875,16.76,35,16.76c24.632,0,44.694-19.895,44.987-44.459
          c0.007-0.052,0.006-0.104,0.008-0.156c0.001-0.129,0.01-0.256,0.01-0.385C476,103,475.997,103,475.994,103.001z M80.998,128
          c-10.222,0-19.027-6.17-22.897-14.979h45.794C100.024,121.83,91.22,128,80.998,128z M105.998,93.021H60.275L86.876,20h19.122
          V93.021z M150.999,128c-10.222,0-19.027-6.17-22.897-14.979h45.794C170.025,121.83,161.221,128,150.999,128z M175.999,93.021
          h-50.001V20h50.001V93.021z M221,128c-10.222,0-19.027-6.17-22.897-14.979h45.794C240.026,121.83,231.222,128,221,128z
          M246,93.021h-50.001V20H246V93.021z M291,128c-10.222,0-19.027-6.17-22.897-14.979h45.794C310.027,121.83,301.223,128,291,128z
          M316.001,93.021H266V20h50.001V93.021z M361.001,128c-10.222,0-19.027-6.17-22.897-14.979h45.794
          C380.028,121.83,371.224,128,361.001,128z M386.002,93.021h-50.001V20h50.001V93.021z M406.002,20h19.122l26.601,73.021h-45.723
          V20z M431.002,128c-10.222,0-19.027-6.17-22.897-14.979H453.9C450.029,121.83,441.225,128,431.002,128z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M221.965,288h-0.131c-5.523,0-10,4.477-10,10s4.477,10,10,10h0.131c5.523,0,10-4.477,10-10S227.488,288,221.965,288z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M64,163.141c-5.523,0-10,4.477-10,10v0.131c0,5.523,4.477,10,10,10s10-4.477,10-10v-0.131
            C74,167.618,69.523,163.141,64,163.141z"/>
          </g>
        </g>
        <g>
          <g>
            <path d="M448,163.141c-5.523,0-10,4.477-10,10v0.131c0,5.523,4.477,10,10,10s10-4.477,10-10v-0.131
              C458,167.618,453.523,163.141,448,163.141z"/>
            </g>
          </g>
          <g>
            <g>
              <path d="M448,195.624c-5.523,0-10,4.477-10,10V320h-6.018c1.939-4.273,3.029-9.01,3.029-14c0-15.686-10.68-28.918-25.149-32.824
                c0.746-2.796,1.149-5.729,1.149-8.757c0-18.748-15.252-34-34-34c-9.359,0-17.846,3.802-24,9.941
                c-6.154-6.139-14.641-9.941-24-9.941c-18.748,0-34,15.252-34,34c0,3.027,0.403,5.961,1.149,8.757
                c-14.469,3.906-25.149,17.138-25.149,32.824c0,4.99,1.089,9.727,3.029,14H266v-54c0-5.523-4.477-10-10-10h-6v-18
                c0-10.37-5.29-19.526-13.311-24.916c0.213-0.019,0.427-0.03,0.644-0.03c5.522,0,10-4.477,10-10c0-5.523-4.477-10-10-10
                c-10.848,0-20.507,6.475-24.942,15.926c-4.67,1.226-8.898,3.552-12.391,6.683c-1.001-0.897-2.061-1.731-3.176-2.489
                c0.432-0.078,0.875-0.12,1.325-0.12c5.522,0,10-4.477,10-10c0-5.523-4.477-10-10-10c-0.001,0,0,0-0.001,0
                c-10.762,0-20.355,6.375-24.836,15.707c-5.034,1.151-9.591,3.567-13.312,6.903c-0.941-0.844-1.937-1.627-2.979-2.348
                c0.623-0.169,1.274-0.261,1.943-0.261c5.522,0,10-4.477,10-10s-4.477-10-10-10c-0.001,0,0,0-0.001,0
                c-10.687,0-20.222,6.285-24.743,15.51C120.436,211.266,110,223.435,110,238v18h-6c-5.523,0-10,4.477-10,10v54H74V205.624
                c0-5.523-4.477-10-10-10s-10,4.477-10,10V329.99c0,0.003,0,0.006,0,0.01v172c0,5.523,4.477,10,10,10h384c5.523,0,10-4.477,10-10
                V336.01c0-0.003,0-0.006,0-0.01V205.624C458,200.101,453.523,195.624,448,195.624z M401.011,292c7.72,0,14,6.28,14,14
                c0,7.72-6.28,14-14,14c-7.72,0-14-6.28-14-14C387.011,298.28,393.291,292,401.011,292z M377.011,250.419c7.72,0,14,6.28,14,14
                c0,7.72-6.28,14-14,14c-7.72,0-14-6.28-14-14C363.011,256.699,369.292,250.419,377.011,250.419z M353.011,292
                c7.72,0,14,6.28,14,14c0,7.72-6.28,14-14,14c-7.72,0-14-6.28-14-14C339.011,298.28,345.291,292,353.011,292z M329.011,250.419
                c7.72,0,14,6.28,14,14c0,7.72-6.28,14-14,14c-7.72,0-14-6.28-14-14C315.011,256.699,321.292,250.419,329.011,250.419z
                M305.011,292c7.72,0,14,6.28,14,14c0,7.72-6.28,14-14,14c-7.72,0-14-6.28-14-14C291.011,298.28,297.291,292,305.011,292z
                M210.001,238c-0.001-5.513,4.482-9.997,9.995-10c0.006,0,0.011,0.001,0.017,0.001c0.003,0,0.006,0,0.009,0
                c5.504,0.012,9.979,4.492,9.979,9.999v18h-20V238z M170,238c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10v18h-20V238z M130,238
                c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10v18h-20V238z M114,308h75.483c5.523,0,10-4.477,10-10s-4.477-10-10-10H114v-12h132
                v44H114V308z M438,492H74V340h30h152h182V492z"/>
              </g>
            </g>
            <g>
              <g>
                <path d="M365.1,386.734c-9.281-9.284-23.264-11.757-34.991-6.923c-15.937-11.351-37.318-11.067-51.634,1.211
                  c-7.707-7.568-18.138-11.965-29.376-11.965c-0.568,0-1.132,0.021-1.695,0.043c-5.535-10.599-16.813-17.645-29.218-17.342
                  c-5.521,0.128-9.893,4.708-9.765,10.229c0.128,5.521,4.706,9.884,10.229,9.765c3.294-0.069,6.388,1.235,8.656,3.413
                  c-9.639,5.874-16.73,15.524-19.223,26.876c-18.839,4.138-32.985,20.952-32.985,41.015c0,23.159,18.841,42,42,42
                  c8.482,0,16.379-2.535,22.989-6.876c0.364,0.438,0.742,0.866,1.15,1.274c3.756,3.757,8.773,5.645,15.221,5.645
                  c9.372,0,21.765-3.991,37.689-12.032c16.825-8.496,35.934-21.08,43.502-28.649c12.331-12.331,14.685-31.078,7.354-46.773
                  c2.198,0.479,4.28,1.556,5.955,3.231c1.953,1.953,4.512,2.929,7.071,2.929s5.118-0.977,7.071-2.929
                  C369.005,396.971,369.006,390.639,365.1,386.734z M238.483,448.216c-0.256,0.813-0.5,1.615-0.722,2.4
                  c-3.09,8.418-11.186,14.44-20.661,14.44c-12.131,0-22-9.869-22-22c0-12.131,9.869-22,22-22c12.131,0,22,9.869,22,22
                  C239.1,444.833,238.883,446.56,238.483,448.216z M228.748,402.712c3.294-8.004,11.174-13.656,20.352-13.656
                  c6.435,0,12.366,2.753,16.48,7.421c-4.664,6.694-9.631,14.685-14.012,22.622C246.125,411.293,238.105,405.418,228.748,402.712z
                  M323.508,430.275c-4.046,4.046-15.094,11.905-27.704,19.163l-7.637-7.637c-3.905-3.905-10.237-3.905-14.143,0
                  c-3.905,3.905-3.905,10.237,0,14.143l3.076,3.076c-12.221,5.391-18.911,6.296-21.461,6.033c-0.156-1.509,0.106-4.483,1.45-9.173
                  c0.153-0.476,0.293-0.958,0.429-1.442c1.643-5.276,4.556-12.477,9.558-21.977c5.478-10.405,11.893-20.489,16.992-27.483
                  l7.294,7.294c1.953,1.953,4.512,2.929,7.071,2.929c2.559,0,5.119-0.977,7.071-2.929c3.905-3.905,3.906-10.237,0-14.142
                  l-6.018-6.018c7.433-1.823,16.05,0.498,22.322,6.77C330.933,408.006,331.695,422.089,323.508,430.275z"/>
                </g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
              <g>
              </g>
            </svg>
  )
}

export default StallIcon
